import client from './client';

const Contracts = {
  getContracts(anketId) {
    return client.get(`/ankets/${anketId}/kf_analytics/contracts`);
  },
};

export default Contracts;
